module.exports = __webpack_public_path__ + "media/images/via-survey-login-0d631cf9c5fa1c74e0d8a6b5ab17a9c6.jpg";